import { Promise } from 'es6-promise';

import { DataProcessor } from './data-processor';
import { repositoryProvider } from '../repositories';

/**
 * @private
 */
export class NetworkDataProcessor extends DataProcessor {
  _getRepository() {
    if (!this._repoPromise) {
      const repo = repositoryProvider.getNetworkRepository();
      this._repoPromise = Promise.resolve(repo);
    }
    return this._repoPromise;
  }
}



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/processors/network-data-processor.js